import { createSelector } from 'reselect';

const getCroppingEnableData = (state) => state.sceneConfiguration.activeLink.cropping.enable;

const getCroppingEnable = createSelector([getCroppingEnableData], (config) => config);

export default getCroppingEnable;
